import React from 'react'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { ButtonBookmarkIcon } from '../../../components'
import { CardImage } from './card-image'

const Card = ({data, embed, bookmark}) => {
  const {
    image,
    date,
    organization,
    title,
    excerpt,
    special
  } = data

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const metaFontSize = embed ? '10px' : isMobile ? '12px' : '14px'
  const withExcerpt = excerpt && !bookmark

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 flex flex-col md:flex-row relative h-full"
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
    >
      <CardImage bookmark={bookmark} isMobile={isMobile} image={image}/>
      <div>
        <p className={`lg:text-sm font-bold ${!organization && 'mb-2'}`} style={{fontSize: metaFontSize}}>{date}</p>
        {
          organization &&
          <p className={`text-gray-999 mb-2`} style={{fontSize: metaFontSize}}>{organization} /</p>
        }
        {
          special &&
          <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>Special Event</div>
        }
        <h3 className={`${withExcerpt ? 'mb-2' : ''} font-bold font-primary ${embed ? 'text-xs' : 'text-sm'} lg:text-lg`}>{title}</h3>
        {/* {
          withExcerpt &&
          <p className="text-sm text-gray-444">{excerpt}</p>
        } */}
      </div>
      {
        bookmark && !isMobile &&
        <ButtonBookmarkIcon className="bg-white m-5 absolute top-0 right-0"/>
      }
    </div>
  )
}

export { Card }
